<app-template-html [value]="value" [control]="control" />
